import { render, staticRenderFns } from "./PopoverTableChair.vue?vue&type=template&id=f9f76440&scoped=true"
import script from "./PopoverTableChair.vue?vue&type=script&lang=js"
export * from "./PopoverTableChair.vue?vue&type=script&lang=js"
import style0 from "./PopoverTableChair.vue?vue&type=style&index=0&id=f9f76440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f76440",
  null
  
)

export default component.exports